import comp from "./CircleLoading";
export default comp;
